import { Box, styled } from '@mui/material';
import * as React from 'react';

import { MAX_WIDTH } from '../../../theme';
import { StandardLayoutProps } from '../../types';

const MaxWidthContainer = styled(Box)({
    width: '100%',
});

export interface MaxWidthLayoutProps extends StandardLayoutProps {
    innerMaxWidth?: number | string;
}

export const MaxWidthLayout: React.FunctionComponent<MaxWidthLayoutProps> = ({
    children,
    innerMaxWidth = MAX_WIDTH,
    ...props
}) => {
    return (
        <Box
            {...props}
            sx={[
                {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '24px',
                    boxSizing: 'border-box',
                },
                ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
            ]}
        >
            <MaxWidthContainer style={{ maxWidth: innerMaxWidth }}>{children}</MaxWidthContainer>
        </Box>
    );
};
